export const HIRO_MAINNET_URL = 'https://api.mainnet.hiro.so';
export const HIRO_TESTNET_URL = 'https://api.testnet.hiro.so';
export const DEVNET_URL = 'http://localhost:3999';

export const GAIA_URL = 'https://hub.blockstack.org';

// todo: deduplicate magic variables

/** @ignore internal */
export const PRIVATE_KEY_BYTES_COMPRESSED = 33;

/** @ignore internal */
export const PRIVATE_KEY_BYTES_UNCOMPRESSED = 32;
